import React, { useCallback } from 'react';
import { injectIntl, FormattedPlural } from 'react-intl';
import cx from 'classnames';
import { Link } from '@ontruck/orc';

import { DISPATCHING } from 'modules/fleet/events';

import AssignmentEventEmitter, { events } from 'modules/dispatching/assignment/events';

import { getDispatchingHeaderDate } from 'utils/itineraries';

const DispatchingListHeader = ({ className, loading, date, total, intl }) => {
  const t = intl.messages.modules.dispatching.list_header;
  const handleCheckCapacity = useCallback(() => {
    DISPATCHING.CHECK_CAPACITY({
      date,
    });
    AssignmentEventEmitter.emit(events.CHECK_CAPACITY, { date });
  }, [date]);

  return (
    <div
      className={cx(className, {
        [`${className}__loading`]: loading,
      })}
    >
      {!!date && (
        <>
          <span className="day">
            {getDispatchingHeaderDate(date, {
              today: t.today,
              tomorrow: t.tomorrow,
              otherDay: t.other_day,
            })}
          </span>
          ({total}&nbsp;
          <FormattedPlural value={total} one={t.route} other={t.routes} />)
          <Link className="capacity" text={t.capacity} onClick={handleCheckCapacity} />
        </>
      )}
    </div>
  );
};

export default injectIntl(DispatchingListHeader);
